import axios from "axios";
import SyncConstants from "../constants/SyncConstants";
import { set_current_user_loading, set_current_user, set_current_user_error } from "../actions/CurrentUser";

export const fetchCurrentUser = (dispatch, userName, syncToken) => {
    dispatch(set_current_user_loading());
    
    if (!userName || !syncToken) {
        dispatch(set_current_user_error("No authentication credentials available"));
        return;
    }
    
    axios({
        method: "get",
        url: SyncConstants["syncBaseURL"] + "current-user",
        auth: {
            username: userName,
            password: syncToken
        }
    })
    .then(response => {
        if (response.data.success) {
            dispatch(set_current_user(response.data.data));
        } else {
            dispatch(set_current_user_error(response.data.error || "Failed to fetch user data"));
        }
    })
    .catch(error => {
        console.error("Error fetching current user:", error);
        dispatch(set_current_user_error(error.message || "Network error"));
    });
};